export default __webpack_public_path__ + "static/cellfabrik_background-389d5edaf885bcab62345d3e6e88b306.jpg";